<template>
  <section class="vote-apply--page">
    <div class="main">
      <myTitle :titleStyle="{color: '#fff', background: '#0F2C87'}" :titleName="'报名'"></myTitle>
      <div class="apply-tittle">
        <div class="class">
          {{$route.query.title}}报名
        </div>
        <div class="form-wrap">
          <div class="line line-name">
            <label for="">公司名称</label>
            <input style="border-bottom: 1px solid #efefef; width: 100%;" v-model="name" placeholder="请输入公司名称" />
          </div>
          <div class="line line-phone">
            <label for="">联系方式</label>
            <input style="border-bottom: 1px solid #efefef; width: 100%;" v-model="phone" placeholder="请输入联系方式" />
          </div>
          <div class="line line-pic">
            <label for="">公司logo<span class="tips">(仅支持jpg,png格式)</span></label>
            <span class="img-choose">{{'选择图片'}}</span>
            <template v-if="fileName">
              已选择：<span class="file-name">{{fileName}}</span>
            </template>
            <input
              id="fileInput"
              type="file"
              name="file"
              @change="chooseUploadFile">
          </div>
          <div class="line line-detail">
            <label for="">公司介绍</label>
            <input style="border-bottom: 1px solid #efefef; width: 100%;" type="textarea" v-model="introduce" placeholder="请输入公司简介" />
          </div>
        </div>
        <div class="block" style="height: 40px"></div>
      </div>
      <div class="bottom-wrap">
        <div class="bottom-main">
          <div class="big-button">
            <div class="rules" @click="seeRules">规则</div>
            <div class="apply" @click="apply">提交</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '../../api/index'
import myTitle from '@/components/title'

export default {
  data () {
    return {
      name: '',
      phone: '',
      fileName: '',
      introduce: ''
    }
  },
  methods: {
    seeRules () {},
    apply () {
      if (!this.name) {
        this.$toast.text('请输入公司名称')
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$toast.text('请输入正确的手机号码')
        return
      }
      if (!this.introduce) {
        this.$toast.text('请输入公司简介')
        return
      }
      if (!this.fileName) {
        this.$toast.text('请选择公司logo')
        return
      }
      this.loading = this.$toast.loading()
      api.applyVote({
        logo: this.batchFile,
        name: this.name,
        phone: this.phone,
        classa: this.$route.query.classa,
        details: this.introduce
      }).then(res => {
        this.loading && this.loading.hide()
        if (res.code === 200) {
          this.$toast.text('报名成功')
        } else {
          this.$toast.text(res.message || '报名出现问题，请稍后再试~')
        }
      })
    },
    chooseUploadFile (e) {
      const file = e.target.files[0]
      if (!file) return
      let fileType = file.name.split('.')
      fileType = fileType[fileType.length - 1]
      if (fileType !== 'jpg' && fileType !== 'png') {
        this.$toast.text('请选择jpg或png格式的图片！')
        return
      }
      this.batchFile = file
      this.fileName = file.name
      e.target.value = ''
    }
  },
  components: {
    myTitle
  }
}
</script>

<style lang="scss">
.vote-apply--page {
  .main {
    background: #f4f5f6;
    width: 7.5rem;
    margin: 0 auto;
    min-height: 10vw;
    .apply-tittle {
      background: #0F2C87;
      height: 300px;
      .class {
        text-align: center;
        height: 120px;
        line-height: 120px;
        color: #fff;
        font-size: 18px;
      }
    }
    .form-wrap {
      background: #fff;
      margin: 12px;
      margin-top: 0;
      border-radius: 8px;
      // position: relative;
      // top: -200px;
      // transform: translateY(-200px);
    }
    .line {
      padding: 12px 24px;
      label {
        display: block;
        font-weight: bold;
        margin-bottom: 8px;
      }
      &.line-pic {
        position: relative;
        .img-choose {
          background: #409EFF;
          color: #fff;
          padding: 4px 6px;
          border-radius: 4px;
          font-size: 12px;
          cursor: pointer;
        }
        .tips {
          color: #83889a;
          font-size: 14px;
          font-weight: normal;
          margin-left: 12px;
        }
        .file-name {
          color: #409EFF;
        }
        input {
          opacity: 0;
          cursor: pointer;
          position: absolute;
          z-index: 10;
          left: 0;
          bottom: 12px;
        }
      }
      &.line-detail {
        // margin-bottom: 44px;
      }
    }
    .bottom-wrap {
      position: fixed;
      bottom: 0;
      left: 50%;
      width: 7.5rem;
      transform: translate(-50%);
      background: #fff;
      .bottom-main {
        display: flex;
        background: #fff;
        align-items: center;
        width: 7.5rem;
        margin: 0 auto;
        border-top: 1px solid #efefef;
        .share {
          padding: 12px;
          display: flex;
          line-height: 1;
          flex-direction: column;
          cursor: pointer;
          .text {
            margin-top: 2px;
            font-size: 12px;
          }
        }
        .big-button {
          flex: 1;
          display: flex;
          border-radius: 4px;
          overflow: hidden;
          cursor: pointer;
          .rules, .apply {
            flex: 1;
            text-align: center;
            line-height: 44px;
            height: 44px;
            color: #fff;
          }
          .rules {
            background: linear-gradient(70deg,#eb934c,#d67946);
          }
          .apply {
            background: linear-gradient(70deg,#376dd6,#1b50b6);
          }
        }
      }
    }
  }
}
</style>
